// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nFocO","badges":"styles_badges__grGxd"};